export type TUserAsset = {
  value: number;
  volume: number;
  profitPercentage: number;
  lastUpdate: string;
};

export type TLivePrice = {
  price: number;
  dailyChangePercentage: number;
};

export type TPerformance = {
  weekly: number | null;
  monthly: number | null;
  quarterly: number | null;
  annually: number | null;
};

export type TPricePoint = {
  value: number;
  date: string;
};

export type TPriceTrend = TPricePoint[];

export enum InsuranceAssetType {
  Gold = 1,
}

export enum InsuranceIndexFilterEnum {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Quarterly = 4,
  Yearly = 5,
}
